import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { Button } from 'react-bootstrap';
import './Welcome.css';

const LogoutButton = () => {
  const { logout } = useAuth0();

  return (
    <Button className="logoutButton"onClick={() => logout({ returnTo: window.location.origin })}>
      Log Out
    </Button>
  );
};

export default LogoutButton;
